exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.captureRow[data-v-328c7987] {\n  display: flex;\n  min-height: 48px;\n}\n.pen[data-v-328c7987] {\n  width: 48px;\n  height: 48px;\n  position: relative;\n}\n.pen + .pen[data-v-328c7987] {\n  margin-left: -16px;\n}\n", ""]);

// exports
